import { ITheme } from '../Models';
import { ISafetyNetSearchParams } from '../Models/SafetyNet/ISafetyNetSearchParams';
import { ISafetyNet } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const SafetyNetService = {
    async getAllSafetyNet(
        searchParams: ISafetyNetSearchParams
    ): Promise<ISafetyNet[]> {
        const response = await fetch('/Api/SafetyNets/GetAll', {
            method: 'POST',
            body: JSON.stringify(searchParams),
            headers,
        });
        return await response.json();
    },
    async getAllThemes(configId: number | null): Promise<ITheme[]> {
        const response = await fetch(
            '/Api/SafetyNets/GetAllThemes?configId=' + configId,
            {
                method: 'Get',
                headers,
            }
        );
        return await response.json();
    },
};
